export const contacts = [
	{
		platform: "Linkedin",
		link: "https://www.linkedin.com/in/mariano-segura-b55a3322b/",
		icon: require('assets/icons/linkedin.webp')  // Linkedin Icon by Unicons Font on Iconscout
	},
	{
		platform: "Github",
		link: "https://github.com/marianosegura",
		icon: require('assets/icons/github.webp')  // Github Icon by Unicons Font on Iconscout
	}
];